<script lang="ts" setup>
import { inject, ref, watchEffect } from "vue";
import { MENU_STORE } from "../../../utils";
import { PageHeaderProps } from "./page-header";

defineOptions({
  name: "IPageHeader",
});

const props = defineProps(PageHeaderProps);
const menuStore = inject(MENU_STORE);
const headerText = ref("");

function setHeaderText() {
  if (props.title) return props.title;
  if (props.action) return props.action?.getCurrentMenu()?.label || "";
  if (menuStore)
    return (
      menuStore.getCurrentMenu()?.label ||
      menuStore.getCurrentMenu()?.menuName ||
      ""
    );
  return "";
}
watchEffect(() => {
  headerText.value = setHeaderText();
});
</script>

<template>
  <div
    class="t-page-header"
    :class="{
      't-page-header__underline': underline,
      't-page-header__between': slotFlex === 'between',
      't-page-header__start': slotFlex === 'start',
    }"
  >
    <div :class="{ 't-page-name': headerText }">{{ headerText }}</div>
    <slot name="default" />
  </div>
</template>
